module.exports = __webpack_public_path__ + "static/media/toolbox_cart_checkout.d751ebfc.svg";